module.exports = __webpack_public_path__ + "media/assets/currency-rates-ff1c8553fb37af87006c529210324d604bf42955638dc0fb1a50be817c7598b3.png";